import { Box } from '@chakra-ui/react';
import { Flex, Text } from '@cmpsr/components';
import { ThemeProvider, createTheme } from '@mui/material';
import { text } from '../../../common/theme';
import { HowItWorksStepper } from './HowItWorksStepper';

const theme = createTheme();

export default function HowItWorks() {
  return (
    <Flex flexDirection="column" gap="spacer-2" alignItems="center" textAlign="center">
      <Text {...text.mobile.h2.primary} fontWeight="700">
        How It Works
      </Text>
      <Text {...text.body.regular}>Catch is built on the world's largest cancer database, empowering you to:</Text>
      <ThemeProvider theme={theme}>
        <Box width="100%" mt={4}>
          <HowItWorksStepper />
        </Box>
      </ThemeProvider>
    </Flex>
  );
}
